import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { MileageField } from 'components/forms/filters/Mileage';
import { MILEAGE_RANGE_NAME } from 'components/searchAds/constants';

import SelectRangeItem from '../SelectRangeItem';

const MIN_NAME = `${MILEAGE_RANGE_NAME}.min`;
const MAX_NAME = `${MILEAGE_RANGE_NAME}.max`;

export default class MileageItem extends PureComponent {
  static propTypes = {
    onChanged: PropTypes.func.isRequired,
  };

  render() {
    const { onChanged } = this.props;

    return (
      <SelectRangeItem
        minName={MIN_NAME}
        maxName={MAX_NAME}
        onChanged={onChanged}
        renderField={(props) => (
          <MileageField {...props} qaSelector="filter-mileage" />
        )}
      />
    );
  }
}
